import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { Image } from "@adora/shared/types/image";

const useAdAssetAdImages = (adAssetGroupId: number, brandId?: string) => {
  const { data, error, isLoading } = useSWR<Image[]>(
    `${RelativeUrl}/ad_asset_groups/${adAssetGroupId}/images?brand_id=${brandId?.toString()}`,
    fetcher
  );

  return {
    images: data || [],
    isLoading,
    error: error ? "Failed to fetch ad images" : null
  };
};

export default useAdAssetAdImages;
